<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="trainingSystemSelected"
                >
                  <v-select
                    v-model="trainingSystemSelected"
                    :options="trainingSystemsOptions"
                    :reduce="(option) => option.value"
                    placeholder="Hệ đào tạo"
                    @input="onChangeTrainingSystem"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label-for="courseSelected"
                >
                  <v-select
                    v-model="courseSelected"
                    :options="courseOptions"
                    :reduce="(option) => option.value"
                    placeholder="Khóa học"
                    @input="onChangeCourse"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="majorSelected"
                >
                  <v-select
                    v-model="majorSelected"
                    :options="majorOptions"
                    :reduce="(option) => option.value"
                    placeholder="Ngành học"
                    @input="onChangeMajor"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label-for="classSelect"
                >
                  <v-select
                    v-model="classSelect"
                    :options="classOptions"
                    placeholder="Lớp sinh viên"
                    :reduce="(option) => option.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="yearSelected"
                >
                  <v-select
                    v-model="yearSelected"
                    :options="yearOptions"
                    :reduce="(option) => option.value"
                    placeholder="Năm học"
                    @input="onChangeYear"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label-for="semesterSelected"
                >
                  <v-select
                    v-model="semesterSelected"
                    :options="semesterOptions"
                    placeholder="Học kỳ"
                    :reduce="(option) => option.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="mr-auto">
                  <b-form-checkbox
                    v-model="firstExam"
                    :value="1"
                    :unchecked-value="0"
                  >
                    Tính theo điểm thi lần 1
                  </b-form-checkbox>
                </div>
                <div class="text-right">
                  <b-button
                    v-show="classSelect > 0 && yearSelected > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    style="margin-right: 5px"
                    @click="onSelect"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="ListIcon" /> Danh sách</span>
                  </b-button>
                  <b-button
                    v-show="itemsTable.length > 0"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    style="margin-right: 5px"
                    @click="exportBangDiemKetQuaHocTap"
                  >
                    <span class="text-nowrap text-right"><feather-icon icon="DownloadIcon" /> Xuất excel</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="mb-2 d-flex flex-wrap align-items-center">
                  <div class="mr-3 stats-block">
                    <strong>Học lực: </strong>
                    <span
                      v-for="s in xlhlStats"
                      :key="`xlhl-${s.label}`"
                      :class="['badge', badgeClassXLHL(s.label), 'mr-1']"
                    >
                      {{ s.label }}: {{ s.percent.toFixed(1) }}% ({{ s.count }})
                    </span>
                  </div>
                  <div class="mr-3 stats-block">
                    <strong>Rèn luyện: </strong>
                    <span
                      v-for="s in xlrlStats"
                      :key="`xlrl-${s.label}`"
                      :class="['badge', badgeClassXLRL(s.label), 'mr-1']"
                    >
                      {{ s.label }}: {{ s.percent.toFixed(1) }}% ({{ s.count }})
                    </span>
                  </div>
                  <div class="ml-auto text-right legend">
                    <span
                      v-if="retakeLegendVisible"
                      class="legend-item ml-2"
                    ><span class="legend-color legend-retake" /> Thi lại</span>
                  </div>
                </div>
                <div style="overflow: auto;">
                  <b-table
                    ref="table"
                    :small="true"
                    :hover="true"
                    :items="itemsTable"
                    :fields="fieldsTable"
                    :tbody-tr-class="rowClass"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer, BFormCheckbox,
  BFormGroup,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { YEARS } from '@/const/status'
import { showErrorToast, showWarningToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import api from './api'

export default {
  name: 'AvgStudentClass',
  directives: {
    Ripple,
  },
  components: {
    BFormCheckbox,
    BTable,
    BButton,
    BFormGroup,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    vSelect,
  },
  data() {
    return {
      allYears: YEARS,
      allTrainingSystems: [],
      listTrainingSystemCourses: [],
      listCourseMajors: [],
      listCourseMajorClasses: [],
      listYearSemesters: [],
      listSubjectsOrder: undefined,
      dataExport: null,

      trainingSystemSelected: undefined,
      courseSelected: undefined,
      majorSelected: undefined,
      classSelect: undefined,
      yearSelected: undefined,
      semesterSelected: undefined,
      firstExam: 0,
      isLoading: false,
      contentRendered: false,
      generatingPdf: false,
      pdfDownloaded: false,
      fieldsTable: [
        'Mã sinh viên',
        'Họ',
        'Tên',
        'Ngày sinh',
        'TBC HT',
        'TBC10 HT',
        'XLHL',
        'Điểm RL',
        'XL RL',
      ],
      itemsTable: [],
      retakeConfig: {
        enabled: false,
        field: 'retake',
        truthyValues: [1, true, 'Y', 'YES'],
      },
    }
  },
  computed: {
    trainingSystemsOptions() {
      return this.allTrainingSystems.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
    courseOptions() {
      return this.listTrainingSystemCourses.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
    majorOptions() {
      return this.listCourseMajors.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
    classOptions() {
      return this.listCourseMajorClasses.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
    yearOptions() {
      return this.allYears
    },
    semesterOptions() {
      return this.listYearSemesters.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },

    totalStudents() {
      return this.itemsTable.length
    },
    xlhlStats() {
      // XLHL column is fixed label 'XLHL'
      const counts = {}
      for (const row of this.itemsTable) {
        const label = row.XLHL || 'Chưa xếp loại'
        counts[label] = (counts[label] || 0) + 1
      }
      const order = ['Xuất sắc', 'Giỏi', 'Khá', 'Trung bình', 'Yếu', 'Kém', 'Chưa xếp loại']
      return Object.keys(counts)
        .map(k => ({ label: k, count: counts[k], percent: this.totalStudents ? (counts[k] * 100) / this.totalStudents : 0 }))
        .sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label))
    },
    xlrlStats() {
      // XL RL column label is 'XL RL'
      const counts = {}
      for (const row of this.itemsTable) {
        const label = row['XL RL'] || 'Chưa xếp loại'
        counts[label] = (counts[label] || 0) + 1
      }
      const order = ['Xuất sắc', 'Tốt', 'Khá', 'Trung bình', 'Yếu', 'Kém', 'Chưa xếp loại']
      return Object.keys(counts)
        .map(k => ({ label: k, count: counts[k], percent: this.totalStudents ? (counts[k] * 100) / this.totalStudents : 0 }))
        .sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label))
    },
    retakeLegendVisible() {
      return this.retakeConfig.enabled
    },
  },
  async created() {
    this.isLoading = true
    try {
      const [trainingSystems] = await Promise.all([api.begin()])
      this.allTrainingSystems = trainingSystems
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    badgeClassXLHL(label) {
      const map = this.sharedBadgeMap()
      return map[label] || 'badge-secondary'
    },
    badgeClassXLRL(label) {
      const map = this.sharedBadgeMap()
      return map[label] || 'badge-secondary'
    },
    sharedBadgeMap() {
      return {
        'Xuất sắc': 'badge-success',
        Giỏi: 'badge-primary',
        Tốt: 'badge-primary',
        Khá: 'badge-info',
        'Trung bình': 'badge-warning',
        Yếu: 'badge-danger',
        Kém: 'badge-dark',
        'Chưa xếp loại': 'badge-secondary',
      }
    },

    onChangeTrainingSystem() {
      if (this.trainingSystemSelected == null) {
        this.reset()
        this.listTrainingSystemCourses = []
        this.listCourseMajors = []
        this.listCourseMajorClasses = []
        this.courseSelected = null
        this.majorSelected = null
        this.classSelect = null
      } else {
        api.getListTrainingSystemCourses({ training_system_id: this.trainingSystemSelected })
          .then(list => { this.listTrainingSystemCourses = list })
          .catch(e => showErrorToast(this, e))
      }
    },
    onChangeCourse() {
      if (this.courseSelected == null) {
        this.reset()
        this.listCourseMajors = []
        this.listCourseMajorClasses = []
        this.majorSelected = null
        this.classSelect = null
      } else {
        api.getListCourseMajors({ course_id: this.courseSelected })
          .then(list => { this.listCourseMajors = list })
          .catch(e => showErrorToast(this, e))
      }
    },
    onChangeMajor() {
      if (this.majorSelected == null) {
        this.reset()
        this.listCourseMajorClasses = []
        this.classSelect = null
      } else {
        api.getListCourseMajorClasses({
          course_id: this.courseSelected,
          major_id: this.majorSelected,
        })
          .then(list => { this.listCourseMajorClasses = list })
          .catch(e => showErrorToast(this, e))
      }
    },
    onChangeYear() {
      if (this.yearSelected == null) {
        this.reset()
        this.listYearSemesters = []
        this.semesterSelected = undefined
      } else {
        api.getListYearSemesters({ year_no: this.yearSelected })
          .then(list => { this.listYearSemesters = list })
          .catch(e => showErrorToast(this, e))
      }
    },
    async reset() {
      this.itemsTable = []
      this.$refs.table.refresh()
      this.listSubjectsOrder = null
      this.fieldsTable = [
        'Mã sinh viên',
        'Họ',
        'Tên',
        'Ngày sinh',
        'TBC HT',
        'TBC10 HT',
        'XLHL',
        'Điểm RL',
        'XL RL',
      ]
    },
    async onSelect() {
      this.isLoading = true
      try {
        const semesterId = this.semesterSelected == null ? 0 : this.semesterSelected
        this.listSubjectsOrder = await api.getListSubjectsOrder({
          class_id: this.classSelect,
          course_id: this.courseSelected,
          year_no: this.yearSelected,
          semester_id: semesterId,
        })
        this.fieldsTable = [
          'Mã sinh viên',
          'Họ',
          'Tên',
          'Ngày sinh',
          'TBC HT',
          'TBC10 HT',
          'XLHL',
          'Điểm RL',
          'XL RL',
        ]
        if (this.listSubjectsOrder !== null) {
          this.fieldsTable.splice.apply(
            this.fieldsTable,
            [4, 0].concat(this.listSubjectsOrder.split(',')),
          )
          const data = await api.getData({
            class_id: this.classSelect,
            course_id: this.courseSelected,
            year_no: this.yearSelected,
            semester_id: semesterId,
            student_id: -1,
            first_value: this.firstExam,
          })
          this.itemsTable = data
        } else {
          await this.reset()
          showWarningToast(this, 'Không có môn học nào trong kỳ này!')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // Highlight row for retake if configured
    rowClass(item, type) {
      if (!item || type !== 'row') return ''
      if (this.retakeConfig.enabled) {
        const v = item[this.retakeConfig.field]
        if (this.retakeConfig.truthyValues.includes(v)) return 'row-retake'
      }
      return ''
    },
    async exportBangDiemKetQuaHocTap() {
      this.isLoading = true
      try {
        const semesterId = this.semesterSelected == null ? 0 : this.semesterSelected
        const blobData = await api.downloadExport({
          class_id: this.classSelect,
          course_id: this.courseSelected,
          year_no: this.yearSelected,
          semester_id: semesterId,
          student_id: -1,
          first_value: this.firstExam,
        })

        const a = document.createElement('a')
        document.body.appendChild(a)
        const blob = new Blob([blobData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = 'bang_ket_qua_hoc_tap.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    exportExcel() {
      this.isLoading = true
      if (this.itemsTable.length > 0) {
        try {
          const tHeader = [
            'Mã sinh viên',
            'Họ và tên',
            'Tên',
            'Ngày sinh',
            'TBC HT',
            'XLHL',
            'Điểm RL',
            'XL RL',
          ]
          // eslint-disable-next-line prefer-spread
          tHeader.splice.apply(
            tHeader,
            [4, 0].concat(this.listSubjectsOrder.split(',')),
          )
          const dataJson = this.formatJson(tHeader, this.itemsTable)
          import('@/utils/Export2Excel').then(excel => {
            excel.export_json_to_excel({
              header: tHeader,
              data: dataJson,
              filename: 'bang_diem_th_theo_lop',
              autoWidth: true,
              bookType: 'xlsx',
            })
          })
        } catch (error) {
          showErrorToast(this, error)
        } finally {
          this.isLoading = false
        }
      } else {
        showWarningToast(this, 'Chưa thực hiện lấy danh sách phách')
        this.isLoading = false
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.reset()
    next()
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.td-low {
  background-color: rgba(255, 0, 0, 0.08);
}
.row-retake {
  background-color: rgba(0, 123, 255, 0.06);
}
.legend {
  .legend-item {
    display: inline-flex;
    align-items: center;
  }
  .legend-color {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    border-radius: 2px;
    border: 1px solid rgba(0,0,0,0.08);
  }
  .legend-retake { background-color: rgba(0, 123, 255, 0.18); }
}
</style>
